import { TypedDocumentNode, gql } from '@apollo/client';

import { footballRivalsInviteAcceptInput } from '@sorare/core/src/__generated__/globalTypes';
import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import {
  FootballRivalsInviteAcceptMutation,
  FootballRivalsInviteAcceptMutationVariables,
} from './__generated__/useFootballRivalsInviteAccept.graphql';

const FOOTBALL_RIVALS_INVITE_ACCEPT_MUTATION = gql`
  mutation FootballRivalsInviteAcceptMutation(
    $input: footballRivalsInviteAcceptInput!
  ) {
    footballRivalsInviteAccept(input: $input) {
      currentManager {
        id
        upcomingReceivedInvitesCount
      }
      invite {
        id
        status
        invitedBy {
          id
          myUpcomingReceivedInvitesCount
        }
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  FootballRivalsInviteAcceptMutation,
  FootballRivalsInviteAcceptMutationVariables
>;

const useFootballRivalsInviteAccept = () => {
  const [mutate] = useMutation(FOOTBALL_RIVALS_INVITE_ACCEPT_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  return async (input: footballRivalsInviteAcceptInput) =>
    mutate({ variables: { input } });
};

export default useFootballRivalsInviteAccept;
